import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';

const LayoutCliente = () => {
  return (
    <div className='layout_cliente_wrapper'>
      <Header className='header' noConfig={true} />
      <main className='main_content_cliente'>
        <div className='container_interno_cliente'>
          <Outlet />
        </div>
      </main>
      <Footer className='footer' />
    </div>
  );
};

export default LayoutCliente;